// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LOlu","left":"styles_left__5FdP6"};